// extracted by mini-css-extract-plugin
export default {"dialog":"_-_-record-it-components-src-modal-ConfirmModal-__dialog","widthTypeDefault":"_-_-record-it-components-src-modal-ConfirmModal-__widthTypeDefault"};